import React from 'react';
import { useShowContextRequired } from "ui-builder";
import { ProjectDetailsField } from "nekst-api";
import { TextBadge, TextBadgeVariant } from "features/nekst-widgets";
import { NewLineBadgeLayout } from "./NewLineBadgeLayout";

export default function IsCommissionField() {
  const showContext = useShowContextRequired<ProjectDetailsField>();

  if (showContext.data.isCommissionField) {
    return (
      <NewLineBadgeLayout>
        <TextBadge
          variant={TextBadgeVariant.PRIMARY}
          text="Commission"
          isSmall
          title="Used to track commission amounts and calculate total commission statistics"
        />
      </NewLineBadgeLayout>
    );
  } else {
    return null;
  }
}
